import React from "react";
import { AnalyticsSummaryResponse } from "../../../api/v2/types";

interface AnalyticsKpiCardsProps {
  summary: AnalyticsSummaryResponse | null;
}

const cardClass = "rounded border p-3";

const AnalyticsKpiCards = ({ summary }: AnalyticsKpiCardsProps) => {
  if (!summary) return null;

  const items = [
    { label: "Total events", value: summary.totalEvents },
    { label: "Failed events", value: summary.failedEvents },
    { label: "Success rate", value: `${summary.successRate.toFixed(1)}%` },
    { label: "Unique actors", value: summary.uniqueActors },
    { label: "Save", value: summary.saveCount },
    { label: "Publish", value: summary.publishCount },
    { label: "Sync keys", value: summary.syncKeysCount },
    { label: "Tree browse", value: summary.treeBrowseCount },
    { label: "Bindings updates", value: summary.bindingsUpdatedCount },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
      {items.map((item) => (
        <div key={item.label} className={cardClass}>
          <p className="text-xs text-muted-foreground">{item.label}</p>
          <p className="text-lg font-semibold">{item.value}</p>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsKpiCards;
